

if (!customElements.get("keen-video")) {
    customElements.define(
    "keen-video",
    class KeenVideo extends HTMLElement {
        constructor() {
            super()
            this.userPaused = false
            this._inited = false
        }

        connectedCallback() {
            if (this._inited) return
            this.isMobile = window.FoxTheme.config.mqlMobile
            this.togglePlayBtn = this.querySelector('.play-toggle-btn')
            this.toggleMuteBtn = this.querySelector('.mute-toggle-btn')
            this.playBtn = this.querySelector('.play-btn')
            this.pauseBtn = this.querySelector('.pause-btn')
            this.muteBtn = this.querySelector('.mute-btn')
            this.unmuteBtn = this.querySelector('.unmute-btn')
            this.videoDom = this.querySelector('video')
            if (!this.videoDom) return
            this._inited = true
            this.init();
            const active = this.closest('.keen-slider-item')?.classList.contains('active')
            this.toggleMuteBtns(Boolean(active))
            this.togglePlayBtns(Boolean(active))
            if (!active) this.pause()
        }

        init() {
            if (!this.videoDom) return
            if (this.togglePlayBtn) {
                this.togglePlayBtn.addEventListener('click', () => {
                    this.userPaused = !this.videoDom.paused
                    if (this.userPaused) this.pause()
                    else this.play()
                })
            }
            this.videoDom.addEventListener('play', () => this.syncPlayButtonState())
            this.videoDom.addEventListener('pause', () => this.syncPlayButtonState())
            this.videoDom.addEventListener('ended', () => {
                this.syncPlayButtonState()
                this.dispatchEvent(new CustomEvent('keen-video-ended', { bubbles: true }))
            })

            if (this.muteBtn && this.unmuteBtn) {
                this.muteBtn.addEventListener('click', () => {
                    this.toggleMuteState()
                })

                this.unmuteBtn.addEventListener('click', () => {
                    this.toggleMuteState()
                })
            }
            this.syncMuteButtonState()
            this.syncPlayButtonState()
        }

        /**
         * 视频源以 data-tp-src 延后输出，只有这一张成为当前张时才注入 src。
         * 未加载前 <video> 显示 poster 封面图，不产生任何 MP4 请求。
         */
        loadSource() {
            const source = this.videoDom?.querySelector('source[data-tp-src]')
            if (!source) return
            source.setAttribute('src', source.dataset.tpSrc)
            source.removeAttribute('data-tp-src')
            this.videoDom.load()
        }

        loadPoster() {
            const poster = this.videoDom?.dataset.tpPoster
            if (!poster) return
            this.videoDom.setAttribute('poster', poster)
            this.videoDom.removeAttribute('data-tp-poster')
        }

        togglePlayBtns(bool) {
            if (!this.togglePlayBtn) return
            const toShow = bool ?? this.togglePlayBtn.classList.has('hidden')
            if (toShow) {
                this.togglePlayBtn.classList.remove('hidden')
            } else{
                this.togglePlayBtn.classList.add('hidden')
            }
        }

        toggleMuteBtns(bool) {
            if (!this.toggleMuteBtn) return
            const toShow = bool ?? this.toggleMuteBtn.classList.has('hidden')
            if (toShow) {
                this.toggleMuteBtn.classList.remove('hidden')
            } else{
                this.toggleMuteBtn.classList.add('hidden')
            }
        }

        syncMuteButtonState() {
            if (!this.videoDom || !this.muteBtn || !this.unmuteBtn) return
            if (this.videoDom.muted) {
                this.muteBtn.classList.remove('hidden')
                this.unmuteBtn.classList.add('hidden')
            } else {
                this.unmuteBtn.classList.remove('hidden')
                this.muteBtn.classList.add('hidden')
            }
        }

        syncPlayButtonState() {
            if (!this.videoDom || !this.playBtn || !this.pauseBtn) return
            this.playBtn.classList.toggle('hidden', !this.videoDom.paused)
            this.pauseBtn.classList.toggle('hidden', this.videoDom.paused)
        }

        setMutedState(muted) {
            if (!this.videoDom) return
            this.videoDom.muted = Boolean(muted)
            this.syncMuteButtonState()
        }

        toggleMuteState() {
            if (!this.videoDom) return
            this.setMutedState(!this.videoDom.muted)
        }

        resetToDefaultMuted() {
            this.setMutedState(true)
        }


        play() {
            if (this.videoDom) {
                this.loadSource()
                this.videoDom.play()?.catch(() => {})
                this.playVideo?.()
            }
        }

        pause() {
            if (this.videoDom) {
                this.videoDom.pause()
                this.pauseVideo?.()
            }
        }

        mute() {
            this.setMutedState(true)
        }

        unmute() {
            this.setMutedState(false)
        }
    })
}


if (!customElements.get("keen-slider")) {
    customElements.define(
    "keen-slider",
    class KeenSlider extends HTMLElement {
        constructor() {
            super()
            this.curIndex = 0
            this.gap = 16
            this.gesture = null
            this.dragOffset = 0
            this.isMouseMoveOver = false
            this.activated = false
            this._inited = false
            this._swipeThreshold = 40
            this._suppressClick = false
            this._onPointerDown = this.handlePointerDown.bind(this)
            this._onPointerUp = this.handlePointerUp.bind(this)
            this._onPointerCancel = this.handlePointerCancel.bind(this)
            this._onPointerMove = this.handlePointerMove.bind(this)
            this._onSlideClick = this.handleSlideClick.bind(this)
            this._onVideoEnded = this.handleVideoEnded.bind(this)
            this._onResize = FoxTheme.utils.debounce(() => {
                if (!this.isConnected) return
                this.handlePointerCancel()
                this.initStyle()
                this.changePositionOfChildren(this.curIndex)
            }, 50)
        }

        connectedCallback() {
            queueMicrotask(() => {
                if (!this.isConnected) return
                if (!this._inited) this.init()
                else if (!this._listening) {
                    this.initStyle()
                    this.changePositionOfChildren(this.curIndex)
                    this.initEvent()
                    this.observeVisibility()
                }
            })
        }

        disconnectedCallback() {
            this.activated = false
            this.handlePointerCancel()
            this.getChildren().forEach(child => child.querySelector('keen-video')?.pause())
            this.visibilityObserver?.disconnect()
            window.removeEventListener('resize', this._onResize)
            this.removeEventListener('pointerdown', this._onPointerDown)
            this.removeEventListener('click', this._onSlideClick)
            this.removeEventListener('keen-video-ended', this._onVideoEnded)
            this._listening = false
        }

        isMobile() {
            return window.matchMedia('(max-width: 767px)').matches
        }

        /*
          与 section 内联 CSS 的卡片宽、视频高保持同一比例。
          桌面 300 / 原 360，手机 234 / 原 280。
        */
        getLayoutMetrics() {
            if (this.isMobile()) {
                return { width: 234, step: 157, yBase: 27, yStep: 18 }
            }
            return { width: 300, step: 210, yBase: 38, yStep: 23 }
        }

        isTablet() {
            return window.FoxTheme.config.mqlTablet
        }

        init() {
            if (this._inited) return
            this._inited = true
            this.initStyle()
            this.initEvent()
            this.initFirstItem()
            this.observeVisibility()
            requestAnimationFrame(() => {
                if (this.gesture?.axis === 'x') return
                this.getChildren().forEach((child) => {
                    child.style.transition = 'opacity .35s linear,transform .5s cubic-bezier(.22,.61,.36,1)'
                })
            })
        }

        /**
         * 首屏只做排版和按钮状态，不加载也不播放视频，
         * 交给 observeVisibility 在整段进入可视区后再启动当前这张。
         */
        initFirstItem() {
            const child = this.children[this.curIndex]
            if (!child) return
            child.classList.add('active')
            const keenVideo = child.querySelector('keen-video')
            if (keenVideo) {
                keenVideo.resetToDefaultMuted()
                keenVideo.toggleMuteBtns(true)
                keenVideo.togglePlayBtns(true)
            }
            this.changePositionOfChildren(this.curIndex)
            this.updateDepthClasses(this.curIndex)
        }

        /**
         * 整段离开可视区就暂停当前视频，避免后台继续播和加载。
         * 只有当前视频真正播放结束后才切下一张。
         */
        observeVisibility() {
            const currentVideo = () => this.children[this.curIndex]?.querySelector('keen-video')

            const enter = () => {
                if (this.activated) return
                this.activated = true
                this.getChildren().forEach((child) => {
                    child.querySelector('keen-video')?.loadPoster()
                })
                this.resumeCurrentVideo()
            }

            const leave = () => {
                if (!this.activated) return
                this.activated = false
                currentVideo()?.pause()
            }

            if (!('IntersectionObserver' in window)) {
                enter()
                return
            }

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
                            enter()
                        } else {
                            leave()
                        }
                    })
                },
                { rootMargin: '0px', threshold: 0.25 }
            )
            observer.observe(this)
            this.visibilityObserver = observer
        }

        initEvent() {
            if (this._listening) return
            this._listening = true
            window.addEventListener('resize', this._onResize)
            this.addEventListener('pointerdown', this._onPointerDown)
            this.addEventListener('click', this._onSlideClick)
            this.addEventListener('keen-video-ended', this._onVideoEnded)
        }

        resumeCurrentVideo() {
            const video = this.children[this.curIndex]?.querySelector('keen-video')
            if (!this.activated || !video || video.userPaused || this.gesture?.axis === 'x') return
            if (video.videoDom?.ended) this.handleVideoEnded({ target: video })
            else video.play()
        }

        handleVideoEnded(event) {
            const current = this.children[this.curIndex]?.querySelector('keen-video')
            if (!this.activated || this.gesture || event.target !== current || !current?.videoDom?.ended || current.userPaused) return
            const count = this.getChildren().length
            if (count > 1) this.setActiveItem((this.curIndex + 1) % count)
            else if (current && !current.userPaused) {
                current.videoDom.currentTime = 0
                current.play()
            }
        }

        isInteractiveTarget(target) {
            return Boolean(target?.closest?.('button, a, [aria-controls]'))
        }

        getSlideIndexFromTarget(target) {
            const item = target?.closest?.('.keen-slider-item')
            if (!item) return -1
            return this.getChildren().indexOf(item)
        }

        /**
         * 只选择最上层实际可交互的卡，不能穿过当前卡选中背后的侧卡。
         */
        activateSlideFromPoint(clientX, clientY) {
            const children = this.getChildren()
            if (!children.length) return false

            if (typeof document.elementsFromPoint === 'function') {
                const stack = document.elementsFromPoint(clientX, clientY)
                for (let i = 0; i < stack.length; i++) {
                    const item = stack[i].closest?.('.keen-slider-item')
                    if (!item || item.parentElement !== this) continue
                    const index = children.indexOf(item)
                    if (index >= 0) {
                        if (index === this.curIndex) return false
                        this.setActiveItem(index)
                        return true
                    }
                }
                return false
            }

            let bestIndex = -1
            let bestDepth = -Infinity
            children.forEach((child, index) => {
                if (child.style.opacity === '0' || child.style.pointerEvents === 'none') return
                const rect = child.getBoundingClientRect()
                if (
                    clientX < rect.left ||
                    clientX > rect.right ||
                    clientY < rect.top ||
                    clientY > rect.bottom
                ) {
                    return
                }
                const depth = Number(child.style.zIndex) || 0
                if (depth > bestDepth) {
                    bestDepth = depth
                    bestIndex = index
                }
            })

            if (bestIndex >= 0 && bestIndex !== this.curIndex) {
                this.setActiveItem(bestIndex)
                return true
            }
            return false
        }

        activateSlideFromTarget(target, clientX, clientY) {
            const index = this.getSlideIndexFromTarget(target)
            if (index >= 0) {
                if (index === this.curIndex) return false
                this.setActiveItem(index)
                return true
            }
            if (clientX != null && clientY != null) {
                return this.activateSlideFromPoint(clientX, clientY)
            }
            return false
        }

        handleSlideClick(e) {
            if (this._suppressClick) {
                this._suppressClick = false
                e.preventDefault()
                e.stopPropagation()
                return
            }
            if (this.isInteractiveTarget(e.target)) return
            this.activateSlideFromTarget(e.target, e.clientX, e.clientY)
        }

        clearStyleAboutLoop() {
            this.getChildren().forEach((child) => {
                child.style.transform = ''
            })
            this.style.left = ''
        }

        getChildren() {
            return Array.from(this.children)
        }

        setActiveItem(index){
            if (index == null || !this.children.length || index < 0 || index >= this.children.length || index === this.curIndex) return
            if (this.gesture) {
                this._suppressClick = true
                this.finishGesture(this.curIndex, false)
            }
            if (this.curIndex !== index) {
                const oldChild = this.children[this.curIndex]
                oldChild.classList.remove('active')
                const keenVideo = oldChild.querySelector('keen-video')
                if(keenVideo) {
                    keenVideo.pause()
                    keenVideo.resetToDefaultMuted()
                    keenVideo.toggleMuteBtns(false)
                    keenVideo.togglePlayBtns(false)
                }
            }
            const newChild = this.children[index]
            newChild.classList.add('active')
            this.curIndex = index
            this.changePositionOfChildren(index)
            this.updateDepthClasses(index)
            const newKeenVideo = newChild.querySelector('keen-video')
            if (newKeenVideo) {
                newKeenVideo.userPaused = false
                if (newKeenVideo.videoDom) newKeenVideo.videoDom.currentTime = 0
                newKeenVideo.resetToDefaultMuted()
                newKeenVideo.toggleMuteBtns(true)
                newKeenVideo.togglePlayBtns(true)
                if (this.activated) newKeenVideo.play()
            }
        }

        updateDepthClasses(index) {
            const children = this.getChildren()
            if (!children.length) return
            children.forEach((child) => {
                child.classList.remove('is-near', 'is-far')
            })
            if (children.length < 3) return

            children.forEach((child, i) => {
                const offset = this.getVisualOffset(i, index, children.length)
                const abs = Math.abs(offset)
                if (abs === 1) child.classList.add('is-near')
                else if (abs > 1) child.classList.add('is-far')
            })
        }

        getVisualOffset(i, index, length) {
            let offset = i - index
            const half = Math.floor(length / 2)
            if (offset > half) offset -= length
            if (offset < -half) offset += length
            return offset
        }

        getDepthTransform(offset) {
            const abs = Math.abs(offset)
            const { step, yBase, yStep } = this.getLayoutMetrics()
            const y = abs <= 1 ? abs * yBase : yBase + (abs - 1) * yStep
            const minScale = this.isMobile() ? 0.52 : 0.56
            return {
                x: offset * step,
                y,
                scale: Math.max(minScale, 1 - abs * 0.11),
                zIndex: 100 - abs
            }
        }

        /** 卡片是否仍在 keen-slider 可视宽度内（超出左右边界则隐藏）。 */
        isSlideWithinViewport(depth) {
            const containerWidth = this.clientWidth
            if (!containerWidth) return true
            const cardWidth = this.getWidthOfChildren()
            const scaledHalf = (cardWidth * depth.scale) / 2
            const centerX = containerWidth / 2 + depth.x
            const left = centerX - scaledHalf
            const right = centerX + scaledHalf
            // 允许轻微溢出，避免“视觉上可见但 pointer-events 被关掉”导致桌面端无法拖拽切换。
            // 容器边界附近的卡片依然应该可交互（尤其是左右相邻卡）。
            const overflowPad = this.isMobile() ? 40 : 80
            return right > -overflowPad && left < containerWidth + overflowPad
        }

        getWidthOfChildren() {
            return this.getLayoutMetrics().width
        }

        initStyle() {
            const width = this.getWidthOfChildren()
            Array.from(this.children).forEach((child) => {
                child.style.flex = `0 0 ${width}px`
                child.style.width = `${width}px`
                child.style.minWidth = `${width}px`
            })
            this.style.left = ''
        }

        checkShouldLoopSlide() {
            // 多张时始终走居中轮播；仅一张时用 normal-list 静态展示。
            return this.getChildren().length > 1
        }

        calculatePositionOfChildren(index) {
            const children = this.getChildren()
            children.forEach((child, i) => {
                const offset = this.getVisualOffset(i, index, children.length)
                const absOffset = Math.abs(offset)
                const dragStep = this.getLayoutMetrics().step
                const depth = this.getDepthTransform(offset + this.dragOffset / dragStep)
                const inViewport = this.isSlideWithinViewport(depth)
                const wrapping = child._keenOffset != null && Math.abs(offset - child._keenOffset) > children.length / 2
                const transition = child.style.transition
                if (wrapping) child.style.transition = 'none'
                child.style.zIndex = String(Math.round(depth.zIndex))
                child.style.transform = `translate3d(calc(-50% + ${depth.x}px), ${depth.y}px, 0) scale(${depth.scale})`
                // 指针可交互策略：
                // - 仅把非常远的卡设置 pointer-events: none
                // - 避免“看起来在侧边可见，但几何判定略不在 viewport”导致桌面拖拽没有事件触发。
                const shouldEnablePointer = absOffset <= 2
                child.style.opacity = inViewport ? '1' : '0'
                child.style.pointerEvents = inViewport && shouldEnablePointer ? '' : 'none'
                child._keenOffset = offset
                if (wrapping) {
                    void child.offsetWidth
                    child.style.transition = transition
                }
            })
        }

        changePositionOfChildren(index) {
            if (index == null) return
            const children = this.getChildren()
            if (index < 0 || index >= children.length) return
            const checkShouldLoopSlide = this.checkShouldLoopSlide()
            if (!checkShouldLoopSlide) {
                this.classList.add('normal-list')
                children.forEach((child) => child.classList.remove('is-near', 'is-far'))
                this.calculatePositionOfChildren(index)
                return false
            } else {
                this.classList.remove('normal-list')
            }
            this.calculatePositionOfChildren(index)
            return true
        }

        handlePointerDown(e) {
            if (this.gesture || e.isPrimary === false) return
            this._suppressClick = false
            if (e.pointerType === 'mouse' && e.button !== 0) return
            if (this.isInteractiveTarget(e.target)) return
            this.gesture = {
                id: e.pointerId,
                startX: e.clientX,
                startY: e.clientY,
                axis: null,
                wasPlaying: false
            }
            window.addEventListener('pointermove', this._onPointerMove, { passive: false })
            window.addEventListener('pointerup', this._onPointerUp)
            window.addEventListener('pointercancel', this._onPointerCancel)
        }

        handlePointerMove(e) {
            const gesture = this.gesture
            if (!gesture || gesture.id !== e.pointerId) return
            const dx = e.clientX - gesture.startX
            const dy = e.clientY - gesture.startY
            if (!gesture.axis) {
                if (Math.max(Math.abs(dx), Math.abs(dy)) < 10) return
                if (Math.abs(dy) > Math.abs(dx) * 1.2) gesture.axis = 'y'
                else if (Math.abs(dx) > Math.abs(dy) * 1.2) {
                    gesture.axis = 'x'
                    const video = this.children[this.curIndex]?.querySelector('keen-video')
                    gesture.wasPlaying = Boolean(video?.videoDom && !video.videoDom.paused)
                    video?.pause()
                    try { this.setPointerCapture(e.pointerId) } catch (err) {}
                    this.getChildren().forEach(child => { child.style.transition = 'none' })
                } else return
            }
            this._suppressClick = true
            if (gesture.axis !== 'x' || this.getChildren().length < 2) return
            if (e.cancelable) e.preventDefault()
            const step = this.getLayoutMetrics().step
            this.dragOffset = Math.max(-step, Math.min(step, dx))
            this.calculatePositionOfChildren(this.curIndex)
        }

        handlePointerUp(e) {
            if (!this.gesture || this.gesture.id !== e.pointerId) return
            this.handlePointerMove(e)
            const dx = e.clientX - this.gesture.startX
            const horizontal = this.gesture.axis === 'x'
            const next = horizontal && Math.abs(dx) >= this._swipeThreshold && this.children.length > 1
                ? (this.curIndex + (dx < 0 ? 1 : -1) + this.children.length) % this.children.length
                : this.curIndex
            this.finishGesture(next)
        }

        handlePointerCancel(e) {
            if (!this.gesture || (e && this.gesture.id !== e.pointerId)) return
            this._suppressClick = true
            this.finishGesture(this.curIndex)
        }

        finishGesture(index, resume = true) {
            const gesture = this.gesture
            if (!gesture) return
            this.gesture = null
            this.dragOffset = 0
            window.removeEventListener('pointermove', this._onPointerMove)
            window.removeEventListener('pointerup', this._onPointerUp)
            window.removeEventListener('pointercancel', this._onPointerCancel)
            try {
                if (this.hasPointerCapture(gesture.id)) this.releasePointerCapture(gesture.id)
            } catch (err) {}
            this.getChildren().forEach(child => {
                child.style.transition = 'opacity .35s linear,transform .5s cubic-bezier(.22,.61,.36,1)'
            })
            if (index !== this.curIndex) this.setActiveItem(index)
            else {
                this.changePositionOfChildren(this.curIndex)
                const video = this.children[this.curIndex]?.querySelector('keen-video')
                if (resume && video?.videoDom?.ended) this.handleVideoEnded({ target: video })
                else if (resume && gesture.wasPlaying && this.activated && !video?.userPaused) video?.play()
            }
        }
    })
}

if (!customElements.get("product-keen-slider")) {
  customElements.define(
    "product-keen-slider",
    class ProductKeenSlider extends HTMLElement {
        constructor() {
            super()
            this.curIndex = 0;
            this._inited = false
        }

        connectedCallback() {
            queueMicrotask(() => {
                if (!this.isConnected || this._inited) return
                this._inited = true
                this.keenSlider = this.querySelector('keen-slider')
                this.init();
            })
        }

        init() {
            this.batchHideVideoBtns()
            this.initNav()
        }

        initNav() {
            const slider = this.keenSlider
            if (!slider) return
            this.querySelector('[data-keen-prev]')?.addEventListener('click', () => {
                const count = slider.getChildren().length
                if (!count) return
                let index = slider.curIndex - 1
                if (index < 0) index = count - 1
                slider.setActiveItem(index)
            })
            this.querySelector('[data-keen-next]')?.addEventListener('click', () => {
                const count = slider.getChildren().length
                if (!count) return
                let index = slider.curIndex + 1
                if (index >= count) index = 0
                slider.setActiveItem(index)
            })
            this.addEventListener('pointerenter', (e) => {
                if (e.pointerType !== 'mouse') return
                this.classList.add('is-nav-hover')
            })
            this.addEventListener('pointerleave', () => {
                this.classList.remove('is-nav-hover')
            })
        }

        batchHideVideoBtns() {
            Array.from(this.querySelectorAll('keen-video')).forEach((video, i) => {
                if (i === this.curIndex) return
                video.toggleMuteBtns(false)
                video.togglePlayBtns(false)
                video.pause()
            })
        }

    })
}
